<template>
  <div class='card'>
    <div class='card-header'>
      <p class='card-header-title is-size-4'>{{ group.name }}</p>
    </div>
    <div class='card-content'>
      <b-table :data='group.prospects'>
        <b-table-column field='name' label='Name' width='10em' v-slot='props'>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field='email' label='Email' v-slot='props'>
          {{ props.row.email }}
        </b-table-column>

        <b-table-column field='link' label='Questionnaire Link' v-slot='props'>
          <div
            class='is-size-7 px-2 py-1 qnr-link'
            @click='copyLink(links[props.row.id])'
            title='Click to copy link'>
            {{ links[props.row.id] }}
          </div>
        </b-table-column>

        <b-table-column field='responded' label='Responded' v-slot='props'>
          <i
            v-if='props.row.has_institutional_response'
            class='fa fa-check-circle has-text-success is-size-4'>
          </i>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>


<script>

export default {
  name: 'client-group',
  components: { /* Subcomponents */ },
  props: ['group'],
  data() {
    return {
      links: {},
    };
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.getSignedLinks();
  },
  updated() {},
  computed: {
  },
  methods: {
    async getSignedLinks() {
      const headers = {
        'Content-Type': 'application/json',
        'X-CSRFToken': this.$root.$data.csrfToken,
      };

      const body = {
        group_id: this.group.id,
        url: '/ui/visitor/institutional-questionnaire/intro',
      };

      const options = {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      };

      const url = '/api/v1/questionnaire/group/share/link/';
      const res = await (await fetch(url, options)).json();
      this.links = res.share_links;
    },
    copyLink(link) {
      console.log(link);
      navigator.clipboard.writeText(link);

      this.$buefy.toast.open({
        message: 'Link copied to clipboard',
        type: 'is-success',
      });
    },
  },
};
</script>


<style scoped>
.qnr-link {
  font-family: monospace;
  border-radius: 0.35em;
}
.qnr-link:hover {
  background-color: lightgray;
  cursor: pointer;
}
</style>
